import { Injectable } from '@angular/core';
import { ComponentCanDeactivate } from './component-can-deactivate';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CanDeactivateGuard {
  constructor(private translateService: TranslateService) {}

  canDeactivate(component: ComponentCanDeactivate): boolean {
    if (!component.canDeactivate()) {
      if (confirm(this.translateService.instant('GENERAL.LEAVING_FORM_WITHOUT_SAVING_MESSAGE'))) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
}
